<!--문의하기-->
@if (isShowInquiryModal) {
  <div class="inquiryModal" [attr.item_list_name]="itemListClass">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="box-dim" (click)="onCloseInquiryModal()"></div>
      <div class="modal-container">
        <div class="modal-header">
          <a class="close" [innerHTML]="'BUTTON.CLOSE' | t" (click)="onCloseInquiryModal()"></a>
        </div>
        <div class="modal-content">
          <div class="scroll">
            <h2 [innerHTML]="'INQUIRY.QUESTIONS' | t">Have any questions?</h2>
            @if (referenceOrderNumber) {
              <div class="order-num">
                {{ 'TERM.ORDER_NUMBER' | t }} : <span>{{ referenceOrderNumber }}</span>
              </div>
            }
            @if (!isRequestProduct) {
              @if (type === INQUIRY_TYPE.PRODUCT) {
                <div class="product-64x64">
                  <dl>
                    <dt
                      [class.out-of-stock]="
                        (product?.mapperSaleProducts)[0].productOption.productStatus === PRODUCT_STATUS.OUT_OF_STOCK
                      "
                    >
                      <img src="{{ (product?.mapperSaleProducts)[0].productOption.images[0].endpoint }}" />
                    </dt>
                    <dd>
                      <p>[{{ (product?.mapperSaleProducts)[0].productOption.brand.englishName }}]</p>
                      <p>
                        <span>{{ product?.englishName }}</span>
                      </p>
                    </dd>
                  </dl>
                </div>
              }
            }
            <div class="product-form">
              <!-- 상품 샐랙트 박스 -->
              <fieldset>
                @if (!isRequestProduct) {
                  @if (type !== INQUIRY_TYPE.PRODUCT) {
                    <div class="field">
                      <mat-form-field class="input-select" [ngClass]="{ displayNonSelectBox: INQUIRY_TYPE.PRODUCT }">
                        <mat-select formControlName="inquiryType" required>
                          @for (code of inquiryTypes; track code) {
                            <mat-option [value]="code.code">
                              {{ code.value }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                }
                @if (isRequestProduct) {
                  <div class="field">
                    <mat-form-field class="input-select">
                      <mat-select formControlName="inquiryType" required>
                        @for (code of inquiryTypes; track code) {
                          <mat-option [value]="code.code">
                            {{ code.value }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                @if (form.get('inquiryType').value === INQUIRY_TYPE.REFUND) {
                  <p class="pink-box">
                    <span [innerHTML]="'INQUIRY.REFUND_NOTE' | t">
                      The return/exchange/refund inquiry is available within 7 days after receiving the products or at
                      the end of the purchase confirmation period.
                    </span>
                  </p>
                }
                <div class="field required">
                  <label>
                    <input type="text" formControlName="subject" maxlength="200" required placeholder="&nbsp;" />
                    <span [innerHTML]="'INQUIRY.TITLE' | t">Title</span>
                  </label>
                </div>
                <p
                  class="error"
                  [style.display]="errors?.form ? 'block' : 'none'"
                  validatorMessage
                  field="subject"
                  [error]="errors?.form"
                ></p>
                <div class="field required" [class.remove]="isRequestProduct">
                  <textarea
                    style="resize: none"
                    formControlName="contents"
                    class="box-textarea"
                    maxlength="4000"
                    placeholder="&nbsp;"
                  ></textarea>
                  @if (form.get('inquiryType').value !== INQUIRY_TYPE.REFUND) {
                    <span [innerHTML]="'INQUIRY.CONTENTS' | t">What can we help you with?</span>
                  }
                  @if (form.get('inquiryType').value === INQUIRY_TYPE.REFUND) {
                    <span [innerHTML]="'INQUIRY.REFUND_CONTENTS' | t">Describe the details of the issues/problems</span>
                  }
                  <p
                    class="error"
                    [style.display]="errors?.form ? 'block' : 'none'"
                    validatorMessage
                    field="contents"
                    [error]="errors?.form"
                  ></p>
                </div>
                @if (form.get('inquiryType').value === INQUIRY_TYPE.REFUND) {
                  <p class="required" [innerHTML]="'INQUIRY.REFUND_ATTACH' | t">
                    * Attach photo(s) that can prove the defect or wrong delivery of the product(s)
                  </p>
                }
                <div class="add-file">
                  <label class="file-label">
                    <span [innerHTML]="'INQUIRY.ATTACH' | t">ATTACH FILE(S)</span>
                    <input
                      #fileInput
                      type="file"
                      accept=".pdf, .jpg, .png, .jpeg, .gif, .svg, .zip, .xls, xlsx, .doc, .docx, .txt, .tiff|image/*"
                      id="upload"
                      (change)="onUpload($event.target['files'])"
                      multiple
                    />
                  </label>
                  @if (attachments.length) {
                    <span>{{ attachments.length }}ea upload</span>
                  }
                </div>
                <!-- display attachment names -->
                @if (attachments.length !== 0) {
                  <div class="file-list">
                    <ul>
                      @for (attachment of attachments; track attachment; let i = $index) {
                        <li class="active">
                          <span class="filename-text">
                            {{ attachment.originFilename }}
                          </span>
                          <span class="filesize-text">
                            {{ attachment.fileSize }}
                          </span>
                          <a (click)="onDeleteAttachment(i)"></a>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </fieldset>
              <p class="noti" [innerHTML]="'INQUIRY.LIMIT_NOTI' | t">
                Registerable extensions<br />: .pdf, .jpg, .png, .zip, .xls, .doc (Up to 10MB in total)
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit">{{ 'BUTTON.SEND' | t }}</button>
        </div>
      </div>
    </form>
  </div>
}
